import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Alert,
} from '@mui/material';
import { Build, Add } from '@mui/icons-material';

const OurServicesPage = () => {
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Our Services
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Manage services displayed on your website
        </Typography>
      </Box>

      {success && (
        <Alert severity="success" sx={{ mb: 3 }} onClose={() => setSuccess('')}>
          {success}
        </Alert>
      )}

      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      <Card>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Build color="primary" />
              <Typography variant="h6" fontWeight={600}>
                Website Services Management
              </Typography>
            </Box>
            <Button
              variant="contained"
              startIcon={<Add />}
              size="small"
            >
              Add Service
            </Button>
          </Box>

          <Alert severity="info">
            This page is under development. You will be able to manage services displayed on your website here.
          </Alert>

          <Grid container spacing={3} sx={{ mt: 2 }}>
            <Grid item xs={12}>
              <Typography variant="body2" color="text.secondary">
                Features coming soon:
              </Typography>
              <ul style={{ marginTop: '8px', color: '#666' }}>
                <li>Add/Edit/Delete website services</li>
                <li>Upload service images</li>
                <li>Manage service descriptions</li>
                <li>Set service pricing</li>
                <li>Enable/Disable services</li>
              </ul>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default OurServicesPage;
